import { render, staticRenderFns } from "./MonthlyTaxSubmissionRecordGrid.vue?vue&type=template&id=1f9c6474"
import script from "./MonthlyTaxSubmissionRecordGrid.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxSubmissionRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports